import { ReactComponent as FolderIcon } from './folder.svg';

export default FolderIcon;
